import { MicrophonePlusIcon } from './MicrophonePlusIcon';

/**
 * author: Michael Richins
 * id 61F84878-9DAD-45D9-8A79-65143EA32F37
 * name microphone-plus
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-plus.svg
 * tags
 */
export const MicrophoneAddIcon = MicrophonePlusIcon;
export default MicrophoneAddIcon